/* global RdcTracking */

import { trackShare } from './shares';
import { trackPhoneLead } from './phone_leads';


const SAVE_SHARE_KEYWORDS = ['save', 'unsave', ':hide', ':unhide', ':calculate-commute'],
      PHOTO_KEYWORDS = ['photo:next', 'photo:prev', 'photo_next', 'photo_prev', 'photo_thumbnail', 'open-slideshow'];

export const setupClickTracking = function(pageName) {
  // Loading quick view calls the page load event, so this is in place so to not add this click handler multiple times.
  if (!window.rdcTrackingInitialized) {
    window.rdcTrackingInitialized = true;
    $(document).on('mouseup', function(e){
      handleOmtag(e.target, pageName, 0);
      handlePhoneTracking(e.target);
    });
  }
};

const handleOmtag = function(target, pageName, count) {
  // allow digging into parent element up to 3 times as the omtag might not always be on the target but on the parent
  if (target && target.attributes['data-omtag']) {
    const omtag = target.attributes['data-omtag'].value;
    let listingId;
    if (['fb', 'tw', 'pt', 'gp'].indexOf(omtag) >= 0) {
      // LGWEB-718 - start
      if (MOVE_DATA.ab_share_srp_experiment) {
        listingId = $('#share_via_email').find('#listing_id').val();
        if (!listingId && target.attributes['data-listing-id']) {
          listingId = target.attributes['data-listing-id'].value;
        }
        if (listingId) {
          listingId = parseInt(listingId);
        }
      }
      trackShare(omtag, false, listingId);
      // LGWEB-718 - end
    } else {
      let clickToken = getClickToken(target);
      trackClick(omtag, pageName, clickToken);
    }
  } else if (count < 3) {
    count++;
    if (target && target.parentElement) {
      handleOmtag(target.parentElement, pageName, count);
    }
  }
};

// trackClick is exported so that we can manually call it whenever the global click handler doesn't work.
export const trackClick = function(omtag, pageName, clickToken='') {
  var eventName = 'click',
      linkName = omtag;
      if(omtag.includes("phone_lead")){
        const dtm = MOVE_DATA.adobeDTM;

        let modifiedOmTag = leadPlacementHandler(omtag);

        const propertyStatus = dtm.propertyStatus,
              leadDelivery = (dtm.listing && dtm.listing.leadDelivery),
              leadPlacement = modifiedOmTag,
              dataSourceType = dtm.dataSourceType;
        trackPhoneLead(propertyStatus, leadDelivery, leadPlacement, dataSourceType);
      } else {
        if (isSpecialClick(omtag, PHOTO_KEYWORDS)) {
          eventName = 'highTrafficClick';
        } else if (isSpecialClick(omtag, SAVE_SHARE_KEYWORDS)) {
          linkName = (pageName && omtagHasPageName(omtag, pageName)) ? omtag : `${pageName}:${omtag}`;
        }
      }
  RdcTracking.trackEvent(eventName, {linkName, 'clickToken': clickToken});
};

const getClickToken = function(target) {
  let propertyId, clickToken;
  if (MOVE_DATA.adobeDTM.pageType === 'ldp-quickview') {
    clickToken = $(target.nextElementSibling).data('clicktoken');
  } else {
    if ($(target).parents('div').is('#ldp-home-values')) {
      if (MOVE_DATA.adobeDTM.propertyStatus === 'not_for_sale') {
        propertyId = $(target).parent().attr('data-propertyid');
        clickToken = $(`.data-wrap#${propertyId}`).data('clicktoken');
      }
    } else {
      propertyId = $(target).parents('.comparable-property-card').attr('data-propertyid');
      clickToken = $(`.data-wrap#${propertyId}`).data('clicktoken');
    }
  }
  return clickToken;
}

const omtagHasPageName = function(omtag='', pageName) {
  return omtag.includes(pageName) || omtag.includes('for_sale') || omtag.includes('for_rent');
}

const isSpecialClick = function(omtag, keywords=[]) {
  for (let i=0; i<keywords.length; i++) {
    if (omtag.includes(keywords[i])) {
      return true;
    }
  }
  return false;
}

const handlePhoneTracking = function(target) {
  const dtm = MOVE_DATA.adobeDTM;

  if (target && target.attributes['data-phone-click-tracking']) {
    const trackingTag = target.attributes['data-phone-click-tracking'].value;

    let modifiedtrackingTag = leadPlacementHandler(trackingTag);

    const propertyStatus = dtm.propertyStatus,
        leadDelivery = (dtm.listing && dtm.listing.leadDelivery),
        leadPlacement = modifiedtrackingTag,
        dataSourceType = dtm.dataSourceType;
    trackPhoneLead(propertyStatus, leadDelivery, leadPlacement, dataSourceType);
  }
}

const leadPlacementHandler = function(trackingTag) {
  //Check for srp, qv or ldp and replace lead_placeholder
  const isSRP = document.getElementById('srp-list') ? true : false;
  let field = 'view';
  let url = window.location.href;
  const isLDPQV = url.indexOf('?' + field + '=') != -1;
  const isLDPModal = document.getElementById('ldpStickyBottomLeadModal') ? true : false;
  if(isLDPQV || isLDPModal)
    return trackingTag.replace("lead_placeholder", "ldp_modal_form");
  else if(isSRP)
    return trackingTag.replace("lead_placeholder", "srp_lead_form");
  else
    return trackingTag.replace("lead_placeholder", "ldp_exposed_form");
}



// WEBPACK FOOTER //
// ./shared_critical/tracking/shared/clicks.js